import { render, staticRenderFns } from "./group-schedule-table.vue?vue&type=template&id=61c281bf"
import script from "./group-schedule-table.vue?vue&type=script&lang=js"
export * from "./group-schedule-table.vue?vue&type=script&lang=js"
import style0 from "./group-schedule-table.vue?vue&type=style&index=0&id=61c281bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../AppData/Roaming/nvm/v12.14.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports